import React from "react";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: "2rem" }}>
    <h2 style={{
      fontSize: "1.15rem", fontWeight: 800, color: "#7C3AED",
      marginBottom: "0.6rem", display: "flex", alignItems: "center", gap: "0.5rem",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#EC4899", display: "inline-block", flexShrink: 0 }} />
      {title}
    </h2>
    <div style={{ color: "#4b5563", fontSize: "0.92rem", lineHeight: 1.75 }}>
      {children}
    </div>
  </div>
);

const TermsOfService = ({ setActiveTab }) => (
  <div style={{ minHeight: "100vh", background: "linear-gradient(135deg,#faf5ff 0%,#fdf2f8 50%,#fff7ed 100%)" }}>

    {/* Hero */}
    <div style={{
      background: "linear-gradient(135deg,#7C3AED 0%,#9333EA 50%,#EC4899 100%)",
      padding: "4rem 1.5rem 3rem", textAlign: "center", position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <div style={{ position: "absolute", top: 0, left: 0, width: 200, height: 200, borderRadius: "50%", background: "rgba(255,255,255,0.05)", filter: "blur(40px)" }} />
        <div style={{ position: "absolute", bottom: 0, right: 0, width: 200, height: 200, borderRadius: "50%", background: "rgba(255,255,255,0.05)", filter: "blur(40px)" }} />
      </div>
      <div style={{ position: "relative", zIndex: 1 }}>
        <span style={{
          display: "inline-block", background: "rgba(255,255,255,0.15)", color: "white",
          fontSize: "0.78rem", fontWeight: 800, padding: "0.35rem 1.1rem", borderRadius: 999,
          letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "1rem",
        }}>📄 Legal</span>
        <h1 style={{ fontSize: "clamp(2rem,5vw,2.8rem)", fontWeight: 900, color: "white", margin: "0 0 0.75rem" }}>
          Terms of Service
        </h1>
        <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem", maxWidth: 520, margin: "0 auto" }}>
          Please read these terms carefully before using our services.
        </p>
        <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "0.78rem", marginTop: "0.75rem" }}>
          Last updated: October 2026
        </p>
      </div>
    </div>

    {/* Content */}
    <div style={{ maxWidth: 800, margin: "0 auto", padding: "3rem 1.5rem" }}>
      <div style={{
        background: "white", borderRadius: "1.5rem", padding: "2.5rem",
        boxShadow: "0 4px 40px rgba(124,58,237,0.08)", border: "1px solid rgba(124,58,237,0.1)",
      }}>
        <p style={{ color: "#6b7280", fontSize: "0.9rem", lineHeight: 1.8, marginBottom: "2rem", padding: "1rem 1.25rem", background: "#faf5ff", borderRadius: "0.75rem", borderLeft: "4px solid #7C3AED" }}>
          By booking an appointment or using the Furpect Tails website, you agree to be bound by these Terms of Service. Please read them carefully.
        </p>

        <Section title="1. Acceptance of Terms">
          <p>
            By accessing our website or booking any service, you confirm that you have read, understood,
            and agree to these Terms of Service. If you do not agree, please do not use our services.
          </p>
        </Section>

        <Section title="2. Services Offered">
          <p>Furpect Tails offers the following services:</p>
          <ul style={{ paddingLeft: "1.25rem", marginTop: "0.5rem" }}>
            <li><strong>Dog & Cat Grooming</strong> — Basic and Full grooming packages, with optional add-ons.</li>
            <li><strong>Pet Hotel & Boarding</strong> — Overnight and day-care stays for dogs and cats.</li>
          </ul>
          <p style={{ marginTop: "0.75rem" }}>
            We reserve the right to modify or discontinue any service at any time without prior notice.
          </p>
        </Section>

        <Section title="3. Vaccination Requirement">
          <p>
            <strong>Strict Store Policy:</strong> For the health and safety of all animals, any dog or cat
            that is <strong>not vaccinated</strong> (or does not have an up-to-date Anti-Rabies vaccination record)
            will <strong>NOT be accepted</strong> in the store. Please bring or upload your pet's vaccination
            card when booking or visiting.
          </p>
        </Section>

        <Section title="4. Tick & Flea Policy">
          <p>
            We do <strong>not</strong> offer medicated baths. Pets must be <strong>free of ticks and fleas</strong> before
            their grooming session. Pets found to have an active infestation upon arrival will not be accepted
            for grooming until properly treated.
          </p>
        </Section>

        <Section title="5. Toothbrush Policy">
          <p>
            For the Teeth Brushing add-on service, pet owners are requested to <strong>bring their pet's own toothbrush</strong>.
            If a toothbrush is not provided, one can be supplied at the clinic for an <strong>additional fee</strong>.
          </p>
        </Section>

        <Section title="6. Booking & Payment">
          <ul style={{ paddingLeft: "1.25rem" }}>
            <li>Appointments can be booked online through our booking system.</li>
            <li>A <strong>10% downpayment</strong> is required to secure your reservation, or you may pay the full amount upfront.</li>
            <li><strong>Downpayments are NON-REFUNDABLE.</strong></li>
            <li>Accepted payment methods: GCash, UnionBank, BDO, and in-store Cash.</li>
            <li>Booking is only confirmed after payment is verified by our admin team.</li>
          </ul>
        </Section>

        <Section title="7. Cancellations & Rescheduling">
          <p>
            Cancellation or rescheduling requests can be submitted through your Customer Dashboard.
            Our admin team will review and process requests promptly. Please notify us as early as possible
            to free up the time slot for other pets. Note that downpayments are <strong>non-refundable</strong> upon cancellation.
          </p>
        </Section>

        <Section title="8. Pet Owner Responsibility">
          <ul style={{ paddingLeft: "1.25rem" }}>
            <li>You represent that you are the owner or authorized caretaker of the pet being brought in.</li>
            <li>You agree to provide accurate health information about your pet, including any medical conditions, allergies, or behavioral concerns.</li>
            <li>You understand that grooming involves handling, which may cause stress to some animals. Our staff take every precaution, but Furpect Tails is not liable for stress-related reactions.</li>
            <li>You agree to pick up your pet at the agreed time after grooming or hotel checkout.</li>
          </ul>
        </Section>

        <Section title="9. Limitation of Liability">
          <p>
            Furpect Tails takes all reasonable care in providing services. However, we are not liable for
            any injury, illness, or loss that occurs as a result of pre-existing conditions, undisclosed
            health issues, or circumstances beyond our control. In the event of an emergency, we will
            contact the owner immediately and may seek veterinary care at the owner's expense.
          </p>
        </Section>

        <Section title="10. Right to Refuse Service">
          <p>
            Furpect Tails reserves the right to refuse service to any pet that poses a safety risk to
            our staff or other animals, is found to have undisclosed health conditions, or violates
            any of the terms stated herein.
          </p>
        </Section>

        <Section title="11. Changes to Terms">
          <p>
            We may update these Terms of Service at any time. Continued use of our services after
            changes are posted constitutes your acceptance of the revised terms.
          </p>
        </Section>

        <Section title="12. Contact Us">
          <p>For questions or concerns regarding these Terms of Service, please reach us at:</p>
          <div style={{ marginTop: "0.75rem", padding: "1rem 1.25rem", background: "#faf5ff", borderRadius: "0.75rem", border: "1px solid rgba(124,58,237,0.1)" }}>
            <p style={{ margin: 0 }}><strong>Furpect Tails Pet Grooming & Hotel</strong></p>
            <p style={{ margin: "0.25rem 0 0" }}>📍 96 Gen. Luna St., Tuktukan, Taguig City</p>
            <p style={{ margin: "0.25rem 0 0" }}>📞 0954 498 8342</p>
          </div>
        </Section>

        {/* Back button */}
        <div style={{ marginTop: "2.5rem", textAlign: "center" }}>
          <button
            onClick={() => setActiveTab("home")}
            style={{
              display: "inline-flex", alignItems: "center", gap: "0.5rem",
              background: "linear-gradient(135deg,#7C3AED,#EC4899)",
              color: "white", fontWeight: 700, fontSize: "0.9rem",
              padding: "0.75rem 2rem", borderRadius: 999, border: "none",
              cursor: "pointer", boxShadow: "0 4px 20px rgba(124,58,237,0.3)",
              transition: "transform 0.2s, box-shadow 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.04)"; e.currentTarget.style.boxShadow = "0 6px 28px rgba(124,58,237,0.4)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(124,58,237,0.3)"; }}
          >
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default TermsOfService;
